import {
  FETCH_POSTS,
  FETCH_SINGLE_POST,
  GET_POSTS,
  GET_SINGLE_POST,
  LOAD_LOCAL
} from '../actions/const';

let config = require('config');

const initialState = {
  posts:null,
  singlePost:null,
  local:[]
};

module.exports = function(state = initialState, action) {
  switch(action.type) {
    case FETCH_POSTS: {
      return Object.assign({}, state, {
        posts:null
      })
    } break;
    case FETCH_SINGLE_POST: {
      return Object.assign({}, state, {
        singlePost:null
      })
    } break;
    case GET_POSTS: {
      return Object.assign({}, state, {
        posts:action.body
      })
    } break;
    case GET_SINGLE_POST: {
      return Object.assign({}, state, {
        singlePost:action.body
      })
    } break;
    case LOAD_LOCAL: {
      return Object.assign({}, state, {
        local:action.local
      })
    } break;
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/data.js